import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
 
import { CardSubComponent } from './card-sub.component';
import { NzIconModule } from 'ng-zorro-antd/icon'; 

const COMPONENTS = [CardSubComponent];

@NgModule({
  imports: [CommonModule, NzAvatarModule, NzToolTipModule,NzIconModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CardSubModule {}
